<template>
  <v-container grid-list-md text-xs-left v-if="agentSingle !== null && pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <!--<h1 class="text-xs-left ma-3">{{agentSingle.agent.user.surname !== null ? agentSingle.agent.user.surname : ''}} {{agentSingle.agent.user.first_name !== null ? agentSingle.agent.user.first_name : ''}} {{agentSingle.agent.user.patronymic !== null ? agentSingle.agent.user.patronymic : ''}}</h1>-->
        <h1 class="text-xs-left ma-3">Данные агента за день</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12 md12 lg12>

        <v-layout class="elevation-1 white mb-4 pa-3">
          <v-flex xs12>
            <v-avatar
                :tile="false"
                :size="72"
                color="grey lighten-4"
                class="ma-3 float-left"
            >
              <img :src="agentSingle.agent.user.photo.url_resized" alt="avatar">
            </v-avatar>
            <div>
              <p class="title mt-4">{{agentSingle.agent.user.surname}} {{agentSingle.agent.user.first_name}} {{agentSingle.agent.user.patronymic}}</p>
              <p class="body-2 mt-3" v-if="agentSingle.agent.user.user_group !== null">{{agentSingle.agent.user.user_group.title}}</p>
            </div>
          </v-flex>
        </v-layout>

        <p class="title">Карта посещений</p>
        <v-layout class="elevation-1 white mb-4 pa-3" v-if="typeof agentSingle.gps_list !== 'undefined'">
          <v-flex xs12>
            <div id="leaflet-map" style="width: 100%; height: 700px;"></div>
          </v-flex>
        </v-layout>

        <p class="title">Список точек по маршруту</p>
        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
                :headers="RoutingPointHeaders"
                :items="RoutingPointItems"
                class="elevation-1 agent-single-table"
                no-data-text="Нет данных"
                hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.point}}</td>
                <td class="text-xs-left">{{ props.item.isVisitedByMark }}</td>
                <td class="text-xs-left">{{ props.item.isVisitedByGps }}</td>
                <td class="text-xs-left">{{ props.item.stayTime }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <p class="title">Список заказов</p>
        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
                :headers="OrderHeaders"
                :items="OrderItems"
                class="elevation-1 agent-single-table agent-order-list-table"
                no-data-text="Нет данных"
                hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.point }}</td>
                <td class="text-xs-left">{{ props.item.createdDatetime }}</td>
                <td class="text-xs-left">{{ props.item.deliveryDate }}</td>
                <td class="text-xs-left">{{ props.item.sum }} ₽</td>
                <td class="text-xs-left">{{ props.item.weight }} кг</td>
                <td class="text-xs-left">{{ props.item.paymentDate }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <p class="title">Список возвратов</p>
        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
                :headers="RefundHeaders"
                :items="RefundItems"
                class="elevation-1 agent-single-table"
                no-data-text="Нет данных"
                hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.point }}</td>
                <td class="text-xs-left">{{ props.item.createdDatetime }}</td>
                <td class="text-xs-left">{{ props.item.refundDate }}</td>
                <td class="text-xs-left">{{ props.item.sum }} ₽</td>
                <td class="text-xs-left">{{ props.item.weight }} кг</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <p class="title">Список платежей</p>
        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
                :headers="PaymentHeaders"
                :items="PaymentItems"
                class="elevation-1 agent-single-table"
                no-data-text="Нет данных"
                hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.point }}</td>
                <td class="text-xs-left">{{ props.item.createdDatetime }}</td>
                <td class="text-xs-left">{{ props.item.sum }} ₽</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import L from 'leaflet'
  import 'leaflet/dist/leaflet.css'
  import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
  import 'leaflet-routing-machine'
  import 'lrm-graphhopper'

  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Рейтинг агентов', link: '/agents/rating'},
          {name: 'Данные агента за день'}
        ],
        pageDataReady: {
          isReady: false,
          agent: false
        },
        RoutingPointHeaders: [
          { text: 'Торговая точка', sortable: false, value: 'point' },
          { text: 'Время посещения по приложению', sortable: false, value: 'isVisitedByMark' },
          { text: 'Время посещения по GPS', sortable: false, value: 'isVisitedByGps' },
          { text: 'Время в магазине по GPS в минутах', sortable: false, value: 'stayTime' }
        ],
        OrderHeaders: [
          { text: 'Торговая точка', sortable: false, value: 'point' },
          { text: 'Время создания', sortable: false, value: 'createdDatetime' },
          { text: 'Дата поставки', sortable: false, value: 'deliveryDate' },
          { text: 'Сумма заказа', sortable: false, value: 'sum' },
          { text: 'Вес заказа', sortable: false, value: 'weight' },
          { text: 'Крайняя дата оплаты долга', sortable: false, value: 'paymentDate' }
        ],
        RefundHeaders: [
          { text: 'Торговая точка', sortable: false, value: 'point' },
          { text: 'Время создания', sortable: false, value: 'createdDatetime' },
          { text: 'Дата вывоза', sortable: false, value: 'refundDate' },
          { text: 'Сумма возврата', sortable: false, value: 'sum' },
          { text: 'Вес возврата', sortable: false, value: 'weight' }
        ],
        PaymentHeaders: [
          { text: 'Торговая точка', sortable: false, value: 'point' },
          { text: 'Дата создания', sortable: false, value: 'createdDatetime' },
          { text: 'Сумма', sortable: false, value: 'sum' }
        ],
        RoutingPointItems: [],
        OrderItems: [],
        RefundItems: [],
        PaymentItems: []
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
      this.$store.commit('setPageTitle', 'Данные агента за день')
      this.$store.dispatch('getAgentSingle', {id: this.$route.params.id, date: this.$route.params.date})
    },
    created () {
      let getParam = ''
      Object.keys(this.$route.query).forEach((item, i) => {
        getParam += i === 0 ? '?' + item + '=' + this.$route.query[item] : '&' + item + '=' + this.$route.query[item]
      })
      this.breadcrumbs[1].link += getParam
    },
    computed: {
      agentSingle () {
        return this.$store.getters.agentSingle
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.agent) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      initMap (instance) {
        this.map = instance
        this.map.behaviors.disable('scrollZoom')
        this.mapZoomUpdate()
      },
      initLeaflet () {
        // Create Leaflet map on map element.
        let map = L.map(document.getElementById('leaflet-map'), {
          preferCanvas: true,
          center: L.latLng(51.533103, 46.034158),
          zoom: 12
        })

        // Add OSM tile layer to the Leaflet map.
        L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map)

        let markers = []
        let lines = []

        let gpsList = this.agentSingle.gps_list
        for (let i = 0; i < gpsList.length; i++) {
          let gps = this.agentSingle.gps_list[i]
          let latLng = L.latLng(gps.coordinate.lat, gps.coordinate.lng)
          lines.push(latLng)

          markers.push(L.circleMarker(latLng, {
            color: '#3388ff',
            radius: 7,
            fillOpacity: 1,
            stroke: false,
            interactive: true
          }).bindPopup('<b>' + this.convertTime(gps.datetime) + '</b>').addTo(map))
        }

        L.polyline(lines, {color: 'black', stroke: 1}).addTo(map)

        if (gpsList.length > 0) {
          let first = L.latLng(gpsList[0].coordinate.lat, gpsList[0].coordinate.lng)
          let last = L.latLng(gpsList[gpsList.length - 1].coordinate.lat, gpsList[gpsList.length - 1].coordinate.lng)

          L.marker(first, {
            title: 'Старт'
          }).addTo(map)

          L.marker(last, {
            title: 'Стоп'
          }).addTo(map)
        }

        let points = []
        let wayPoints = []
        for (let i = 0; i < this.agentSingle.routing_point_list.length; i++) {
          let point = this.agentSingle.routing_point_list[i].point
          let latLng = L.latLng(point.coordinate.lat, point.coordinate.lng)

          wayPoints.push(latLng)

          points.push(L.marker(latLng, {
            title: point.title,
            icon: new L.Icon({
              iconUrl: '/static/img/maps-and-flags.svg',
              iconRetinaUrl: '/static/img/maps-and-flags.svg',
              shadowUrl: null,
              iconSize: [36, 36]
            })
          }).bindPopup('<b>' + point.title + '</b><br>' + point.fact_address).addTo(map))
        }

        if (points.length > 0) {
          map.fitBounds((new L.FeatureGroup(points)).getBounds())
        }

        L.Routing.control({
          router: new L.Routing.GraphHopper('', {
            serviceUrl: 'https://backendv2.producto.store:746/route'
          }),
          show: false,
          waypoints: wayPoints
        }).addTo(map)
      },
      balloonTemplate (date) {
        return `
            <p><span class="font-weight-bold">Время:</span> ${this.$moment(date).format('HH:mm')}</p>
          `
      },
      convertTime (dt) {
        return dt !== null ? this.$moment(dt).format('HH:mm') : '–'
      },
      mapZoomUpdate () {
        if (this.map !== null && this.map.geoObjects.getBounds() !== null) {
          this.map.setBounds(this.map.geoObjects.getBounds())
          if (this.map.getZoom() > 18) {
            this.map.setZoom(18)
          }
        }
      },
      stayTimeFormate (stayTime) {
        if (stayTime === null || typeof stayTime === 'undefined' || stayTime === 0) {
          return '-'
        } else {
          return Math.floor(stayTime / 60)
        }
      },
      visitedDatatime (isVisited, datetimeVisited) {
        if (isVisited === 1) {
          return datetimeVisited !== null ? this.$moment(datetimeVisited).format('HH:mm') : 'Да'
        } else {
          return 'Нет'
        }
      }
    },
    watch: {
      agentSingle (val) {
        this.pageDataReady.agent = true
        this.pageDataStatus()
        let routingPointTotal = {visitedByMarkTotal: 0, visitedByGpsTotal: 0}
        let orderTotal = {sumTotal: 0, weightTotal: 0}
        let refundTotal = {sumTotal: 0, weightTotal: 0}
        let paymentPointTotal = {sumTotal: 0}

        for (let i = 0; i < this.agentSingle.routing_point_list.length; i++) {
          if (this.agentSingle.routing_point_list[i].is_visited_by_mark === 1) {
            routingPointTotal.visitedByMarkTotal++
          }
          if (this.agentSingle.routing_point_list[i].is_visited_by_gps === 1) {
            routingPointTotal.visitedByGpsTotal++
          }
          this.RoutingPointItems[i] = {
            point: this.agentSingle.routing_point_list[i].point.title,
            isVisitedByMark: this.visitedDatatime(this.agentSingle.routing_point_list[i].is_visited_by_mark, this.agentSingle.routing_point_list[i].datetime_visited_by_mark),
            isVisitedByGps: this.visitedDatatime(this.agentSingle.routing_point_list[i].is_visited_by_gps, this.agentSingle.routing_point_list[i].datetime_visited_by_gps),
            stayTime: this.stayTimeFormate(this.agentSingle.routing_point_list[i].stay_time)
          }
        }
        this.RoutingPointItems[this.RoutingPointItems.length] = {
          point: 'Итого',
          isVisitedByMark: routingPointTotal.visitedByMarkTotal,
          isVisitedByGps: routingPointTotal.visitedByGpsTotal,
          stayTime: ''
        }

        for (let i = 0; i < this.agentSingle.order_list.length; i++) {
          if (!isNaN(this.agentSingle.order_list[i].sum)) {
            orderTotal.sumTotal += this.agentSingle.order_list[i].sum
          }
          if (!isNaN(this.agentSingle.order_list[i].weight)) {
            orderTotal.weightTotal += this.agentSingle.order_list[i].weight
          }
          this.OrderItems[i] = {
            point: this.agentSingle.order_list[i].point !== null ? this.agentSingle.order_list[i].point.title : '',
            createdDatetime: this.agentSingle.order_list[i].created_datetime != null ? this.$moment(this.agentSingle.order_list[i].created_datetime).format('DD.MM.YYYY HH:mm') : '',
            deliveryDate: this.agentSingle.order_list[i].delivery_date !== null ? this.$moment(this.agentSingle.order_list[i].delivery_date).format('DD.MM.YYYY') : '',
            sum: this.agentSingle.order_list[i].sum,
            weight: this.agentSingle.order_list[i].weight,
            paymentDate: this.agentSingle.order_list[i].payment_date !== null ? this.$moment(this.agentSingle.order_list[i].payment_date).format('DD.MM.YYYY') : ''
          }
        }
        this.OrderItems[this.OrderItems.length] = {
          point: 'Итого',
          createdDatetime: '',
          deliveryDate: '',
          sum: orderTotal.sumTotal.toFixed(2),
          weight: orderTotal.weightTotal.toFixed(2),
          paymentDate: ''
        }

        for (let i = 0; i < this.agentSingle.refund_list.length; i++) {
          if (!isNaN(this.agentSingle.refund_list[i].sum)) {
            refundTotal.sumTotal += this.agentSingle.refund_list[i].sum
          }
          if (!isNaN(this.agentSingle.refund_list[i].weight)) {
            refundTotal.weightTotal += this.agentSingle.refund_list[i].weight
          }
          this.RefundItems[i] = {
            point: this.agentSingle.refund_list[i].point !== null ? this.agentSingle.refund_list[i].point.title : '',
            createdDatetime: this.agentSingle.refund_list[i].created_datetime != null ? this.$moment(this.agentSingle.refund_list[i].created_datetime).format('DD.MM.YYYY HH:mm') : '',
            refundDate: this.agentSingle.refund_list[i].refund_date !== null ? this.$moment(this.agentSingle.refund_list[i].refund_date).format('DD.MM.YYYY') : '',
            sum: this.agentSingle.refund_list[i].sum,
            weight: this.agentSingle.refund_list[i].weight
          }
        }
        this.RefundItems[this.RefundItems.length] = {
          point: 'Итого',
          createdDatetime: '',
          refundDate: '',
          sum: refundTotal.sumTotal.toFixed(2),
          weight: refundTotal.weightTotal.toFixed(2)
        }

        for (let i = 0; i < this.agentSingle.payment_list.length; i++) {
          if (!isNaN(this.agentSingle.payment_list[i].sum)) {
            paymentPointTotal.sumTotal += this.agentSingle.payment_list[i].sum
          }
          this.PaymentItems[i] = {
            point: this.agentSingle.payment_list[i].point !== null ? this.agentSingle.payment_list[i].point.title : '',
            createdDatetime: this.agentSingle.payment_list[i].created_datetime != null ? this.$moment(this.agentSingle.payment_list[i].created_datetime).format('DD.MM.YYYY HH:mm') : '',
            sum: this.agentSingle.payment_list[i].sum
          }
        }
        this.PaymentItems[this.PaymentItems.length] = {
          point: 'Итого',
          createdDatetime: '',
          sum: paymentPointTotal.sumTotal.toFixed(2)
        }

        this.agentSingle.gpsPath = this.agentSingle.gps_list.map(item => {
          return [item.coordinate.lat, item.coordinate.lng]
        })

        this.agentSingle.gps_list.forEach((item, i) => {
          if (i === 0) {
            this.agentSingle.gps_list[i].icon = '/static/img/placeholder-icon1.png'
          } else if (i === this.agentSingle.gps_list.length - 1) {
            this.agentSingle.gps_list[i].icon = '/static/img/placeholder-icon3.png'
          } else {
            this.agentSingle.gps_list[i].icon = '/static/img/placeholder-icon2.png'
          }
        })
      }
    },
    updated () {
      this.initLeaflet()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Agents/AgentSingle.vue